/* eslint-disable import/prefer-default-export */
import React from 'react';

import { Tabs } from '@eika/tabs';

import useTranslation from '../../../hooks/useTranslation';
import { useSigningContext } from '../../../signingContext/signingContext';
import useFocusContext from '../../NettbankCreateTransactions/hooks/useFocusContext';

export const PaymentAndTransferFormTabs: React.FC = () => {
    const translated = useTranslation();

    const { active, toggleSwitchState, transactionType } = useFocusContext();
    const { signingOperationPending } = useSigningContext();

    return (
        <Tabs.TabList>
            <Tabs.TabButton
                disabled={signingOperationPending || toggleSwitchState.value === 'disabled'}
                value="payment"
                tabIndex={!active.value || transactionType.value !== 'payment' ? -1 : 0}
            >
                {translated.payment}
            </Tabs.TabButton>
            <Tabs.TabButton
                disabled={signingOperationPending || toggleSwitchState.value === 'disabled'}
                value="transfer"
                tabIndex={!active.value || transactionType.value !== 'transfer' ? -1 : 0}
            >
                {translated.transfer}
            </Tabs.TabButton>
        </Tabs.TabList>
    );
};
